import type { ReactNode } from 'react';
import styles from './Text.module.css';

export interface TextProps {
  /** Text size token (r1=18px body, r2=16px, r3=14px, r4=12px) */
  size?: 'r1' | 'r2' | 'r3' | 'r4';
  /** R1 color token name (default: n999) */
  color?: string;
  align?: 'left' | 'center' | 'right';
  weight?: 'light' | 'regular' | 'bold';
  /** HTML element to render */
  as?: 'p' | 'span' | 'div';
  className?: string;
  children: ReactNode;
}

export function Text({
  size = 'r1',
  color = 'n999',
  align = 'left',
  weight = 'regular',
  as: Tag = 'p',
  className,
  children,
}: TextProps) {
  return (
    <Tag
      data-crd-id="r2.bq-text"
      data-crd-layer="r2"
      className={`${styles.text} ${styles[size]} ${styles[weight]} ${className ?? ''}`}
      style={{
        color: `rgba(var(--bq-${color}), 1)`,
        textAlign: align,
      }}
    >
      {children}
    </Tag>
  );
}
